import { ChainSymbol } from './chains';

export type TokenSymbol =
  | 'KSTA'
  // | 'KOK'
  | 'ETH'
  | 'USDT'
  // | 'ksKOK'
  | 'ksETH'
  | 'ksUSDT';

export interface Token {
  symbol: TokenSymbol;
  decimals: number;
  name: string;
  logoUrl: string;
  bridgeFee: number;
  // 토큰 선택시 soon 표시 띄울지 여부
  isComingSoon?: boolean;
}

export const tokens: Token[] = [
  {
    symbol: `KSTA`,
    decimals: 18,
    name: `KSTA`,
    logoUrl: `/dummy/KSTA.png`,
    bridgeFee: 10,
  },
  // {
  //   symbol: `KOK`,
  //   decimals: 18,
  //   name: `KOK`,
  //   logoUrl: `/dummy/KOK.png`,
  //   bridgeFee: 10,
  // },
  {
    symbol: `ETH`,
    decimals: 18,
    name: `ETH`,
    logoUrl: `/dummy/ETH.png`,
    bridgeFee: 10,
  },
  {
    symbol: `USDT`,
    decimals: 6,
    name: `USDT`,
    logoUrl: `/dummy/USDT.png`,
    bridgeFee: 10,
  },
];

export const ksTokens: Token[] = [
  {
    symbol: `KSTA`,
    decimals: 18,
    name: `KSTA`,
    logoUrl: `/dummy/KSTA.png`,
    bridgeFee: 10,
  },
  // {
  //   symbol: `ksKOK`,
  //   decimals: 18,
  //   name: `ksKOK`,
  //   logoUrl: `/dummy/KOK.png`,
  //   bridgeFee: 10,
  // },
  {
    symbol: `ksETH`,
    decimals: 18,
    name: `ksETH`,
    logoUrl: `/dummy/ETH.png`,
    bridgeFee: 10,
  },
  {
    symbol: `ksUSDT`,
    decimals: 18,
    name: `ksUSDT`,
    logoUrl: `/dummy/USDT.png`,
    bridgeFee: 10,
  },
];

export const findTokenBySymbol = (
  symbol: string,
  chain: ChainSymbol = `ETH`,
): Token | undefined => {
  const tokenList = chain === `ETH` ? tokens : ksTokens;
  return tokenList.find((token) => token.symbol.includes(symbol));
};

export default tokens;
